module.exports = __webpack_public_path__ + "img/cat_damaged.63d4c3dd.png";